import React from "react";
import "./HeroSection.css";
// import MyPhoto from "../../Assets/image.png";
import MyPhoto from "../../Assets/mo2.jpg";
const HeroSection = () => {
  return (
    <section className="hero-section" id="home">
      <div className="container">
        <div className="info">
          <span>
            Hello <span>👋</span>
          </span>
          <h2>I'm Mohamed</h2>
          <h3>Front-End Developer </h3>
          <p>
            I possess a strong skill set in HTML, CSS, and JavaScript, along
            with expertise in modern frameworks like React. I have a proven
            track record of delivering visually appealing and user-friendly web
            applications. With a passion for clean code and attention to detail,
            I strive to create seamless user experiences that exceed
            expectations.
          </p>
          <div className="social-icons">
            <a
              href="https://www.linkedin.com/in/mohamed-salah-a74b5b234/"
              rel="noopener noreferrer"
              target="_blank"
            >
              <i className="fa-brands fa-linkedin"></i>
            </a>
            <a
              href="https://github.com/Mohamed-Salah991"
              rel="noopener noreferrer"
              target="_blank"
            >
              <i className="fa-brands fa-github"></i>
            </a>
          </div>
          {/* <button>My Works</button> */}
        </div>
        <div className="image">
          <div className="block">
            <img src={MyPhoto} alt="" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
